export const enumGlobalOptionData = {
    TITLE : 'TITLE', 
    ORG_TYPE: 'ORG_TYPE', 
    DOC_TYPE: 'DOC_TYPE', 
    SYS_CAP: 'SYS_CAP', 
    INDUS_TYPE:'INDUS_TYPE',
    PRT_TYPE: 'PRT_TYPE',
}

export const enumGlobalOptionDataMap = {
    tenant_title : 'TITLE', 
    tenant_type: 'ORG_TYPE', 
    tenant_RegDocuments: 'DOC_TYPE', 
    tenant_systemCapabilities: 'SYS_CAP', 
    tenant_industryType:'INDUS_TYPE',
    PRT_TYPE: 'PRT_TYPE',
}

export const moduleTypeEnum = {
    enum: "Enum",
    menu: "Menu"
}